export default "__VITE_ASSET__CTzkWjli__"